const permissionsList = {
  RolesAndPermissions: 'RolesAndPermissions',
  Users: 'Users',
  VehicleGroup: 'VehicleGroup',
  LevelOfService: 'LevelOfService',
  VehicleType: 'VehicleType',
  Vehicle: 'Vehicle',
  Patient: 'Patient',
  Driver: 'Driver',
  BillingItem: 'BillingItem',
  Payor: 'Payor',
  BillingItemRate: 'BillingItemRate',
  DynamicForm: 'DynamicForm',
  Trip: 'Trip',
  Facility: 'Facility',
  ProviderInvitation: 'ProviderInvitation',
  Zones: 'Zones',
  SystemAdmin: 'SystemAdmin',
  CompanyInfo: 'CompanyInfo',
  Connections: 'Connections',
  CanAcceptTrip: 'CanAcceptTrip',
  CanViewActivityLog: 'CanViewActivityLog',
  CanSeeCharge: 'CanSeeCharge',
  Invoice: 'Invoice',
  ManagePaymentMethods: 'ManagePaymentMethods',
  CanManageFacilityPayments: 'CanManageFacilityPayments',
  OpenAPI: 'OpenAPI',
  CanTakeTrip: 'CanTakeTrip',
  Dashboard: 'Dashboard',
  CanSeeSSN: 'CanSeeSSN',
  CanCreateTripInPast: 'CanCreateTripInPast',
  ReleaseTrip: 'ReleaseTrip',
  CanDoDiscount: 'CanDoDiscount',
  CanSeeTabs: 'CanSeeTabs'
};
export default permissionsList;
